export const isAvailbleForceSave: Record<string, boolean> = {
  "Carton was already accepted": false,
  "Weight=0, contact Yael": false,
  "Wrong destination or certificate, please confirm": true,
  "Carton accepted": true
}